<template>

    <div class="box-shadow-inside box-background box-ssjc mt20" style="height: 829px;">
        <div class="box-title flex-between">
            <div class="box-title-text box-title-bg02">
                <p class="">地图预览</p>
            </div>
            <div class="box-title-right">
            </div>
        </div>
        <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            class="leaflet-zoom-animated"
            viewBox="0 0 950 770"
            xml:space="preserve">
            <g class="hand">
                <path class="leaflet-interactive" id="XSQ" d="M922 307L915 310L904 308L898 311L890 303L885 309L883 315L879 316L878 318L876 318L876 316L874 315L866 316L861 314L853 320L843 322L837 321L830 324L824 324L821 327L817 328L818 335L824 338L820 344L812 352L808 351L801 353L801 362L798 363L793 361L786 363L785 365L785 376L803 378L805 382L798 382L801 390L801 399L803 400L801 403L802 405L818 399L825 404L827 403L826 398L829 396L836 396L837 394L846 399L852 399L855 404L859 406L863 404L863 406L866 406L866 408L871 409L871 412L875 410L882 413L884 424L890 428L893 427L895 429L892 432L890 444L892 442L898 452L904 452L907 455L908 459L908 453L906 451L905 446L909 440L916 437L927 428L929 429L931 435L935 430L933 422L934 417L931 415L930 402L925 394L918 393L915 394L918 398L915 399L913 397L906 399L904 397L905 394L903 393L902 383L908 381L910 384L915 383L915 379L920 376L927 377L932 374L928 369L929 365L926 362L930 358L928 354L912 351L910 349L915 348L915 337L913 337L916 331L920 330L919 329L921 330L921 328L924 328L930 320L932 320L931 317L924 315L923 311z"/>
                <path class="leaflet-interactive" id="HSQ"  d="M661 412L670 409L681 403L681 401L684 401L684 399L689 398L692 395L706 388L709 406L712 406L714 411L719 405L723 408L725 406L725 403L735 398L736 399L737 397L733 390L734 389L747 389L750 384L747 375L750 372L748 369L753 368L758 373L762 366L777 369L784 373L786 363L793 361L798 363L800 362L801 353L813 351L824 339L823 337L818 335L817 329L808 331L787 323L776 325L769 323L764 309L755 312L754 309L745 307L741 307L739 309L729 308L726 292L718 294L715 289L712 289L710 287L705 288L703 289L703 306L706 313L703 316L704 322L698 326L696 331L700 332L701 335L697 338L689 333L688 349L684 366L677 367L662 380L661 387L655 395L652 396L653 409L658 413L660 412z"/>
                <path class="leaflet-interactive" id="BHQ" d="M674 544L680 587L712 560L731 538L806 495L805 468L809 462L807 461L806 452L808 451L804 440L810 437L802 428L797 427L789 437L784 437L781 434L783 429L776 431L776 426L773 423L771 423L770 415L772 410L765 396L754 396L749 392L748 389L744 388L734 389L733 390L737 397L736 399L735 398L725 403L724 408L719 405L715 411L712 406L709 406L708 404L706 388L691 397L684 399L684 401L681 401L681 403L670 409L661 412L664 412L664 414L673 415L674 417L671 419L674 419L676 421L676 437L680 436L682 433L685 436L684 441L686 442L686 438L690 442L686 445L679 456L677 463L680 468L663 475L651 484L643 518L644 529L652 532L671 533L675 542z"/>
                <path class="leaflet-interactive" id="LXQ" d="M801 399L801 390L798 382L805 382L803 378L785 376L785 373L777 369L762 366L758 373L753 368L748 369L750 372L747 375L750 384L748 389L749 392L754 396L765 396L767 398L767 402L772 410L770 414L771 422L776 426L776 431L783 429L783 432L781 434L784 437L791 435L797 427L802 428L796 421L799 417L795 410L790 410L788 403L790 403L787 402L787 400L784 400L786 400L785 399L786 397L786 399L787 398L787 396L790 401L791 400L789 399L793 400L793 403L791 402L794 402L793 398L796 400L799 399z"/>
                <path class="leaflet-interactive" id="XWQ" d="M802 428L810 437L804 440L808 450L806 452L807 461L809 462L805 468L806 495L838 476L842 478L845 477L847 479L845 476L860 478L867 477L870 475L878 476L881 470L885 472L889 470L889 466L893 464L899 465L908 459L904 452L898 452L893 443L892 442L890 444L890 437L892 436L892 432L895 429L893 427L890 428L884 424L882 413L875 410L871 412L871 409L866 408L866 406L863 406L863 404L859 406L857 404L855 405L852 399L849 400L837 394L836 396L829 396L826 398L827 403L825 404L822 400L819 399L802 405L801 403L803 400L795 400L794 398L794 402L791 403L793 403L793 400L789 399L791 400L790 401L787 397L786 399L786 397L786 400L784 400L787 400L787 402L790 403L788 403L788 409L795 410L799 417L796 421L801 428z"/>
                <path class="leaflet-interactive" id="JY" d="M922 307L924 303L926 303L932 297L929 287L926 286L924 274L917 267L910 272L909 267L897 271L892 259L892 257L896 254L896 246L888 238L882 238L881 232L876 224L876 220L864 215L863 210L842 204L830 198L825 199L818 195L819 191L824 187L824 183L815 175L813 166L814 148L805 154L745 183L729 184L692 179L634 162L627 172L627 181L634 191L631 194L626 195L623 199L624 202L622 206L624 209L626 209L627 213L630 214L628 218L630 220L627 223L627 225L625 225L625 227L618 230L619 233L623 236L623 239L625 240L626 248L628 247L629 249L633 249L636 244L638 244L639 248L646 250L667 231L682 230L686 227L697 228L698 225L704 222L713 221L717 224L718 229L716 234L707 243L707 245L708 248L711 249L711 253L715 256L713 263L719 273L722 283L725 286L727 285L728 287L726 288L729 289L729 292L726 292L729 308L739 309L741 307L745 307L754 309L755 312L764 309L769 323L776 325L787 323L808 331L820 327L824 324L828 325L837 321L843 322L853 320L861 314L866 316L874 315L876 316L876 318L878 318L879 316L883 315L884 309L890 303L898 311L904 308L912 310L922 308z"/>
                <path class="leaflet-interactive" id="YX" d="M674 544L669 546L644 538L635 526L634 515L637 500L641 494L647 457L645 453L646 451L641 446L634 444L631 441L626 443L621 440L621 446L609 435L608 423L596 419L590 413L570 417L553 417L544 427L541 428L537 427L524 415L509 412L501 412L492 408L485 407L476 411L473 399L468 399L461 382L455 382L454 379L448 378L443 381L440 381L437 384L437 390L439 391L439 395L441 398L440 401L431 409L426 409L421 413L418 421L415 423L413 427L408 442L400 442L400 451L404 456L403 462L399 462L398 464L399 466L411 465L413 467L411 470L412 476L408 477L408 482L405 487L393 485L393 498L389 497L384 500L387 508L380 526L381 547L376 554L378 565L383 569L381 579L384 580L384 582L381 584L382 592L379 594L380 597L377 600L393 613L393 638L384 645L382 650L389 657L396 661L402 668L405 680L417 680L424 668L433 667L437 664L436 661L438 657L442 653L446 653L450 646L457 645L459 649L470 655L474 650L475 645L477 644L488 642L493 644L509 638L516 643L514 648L515 652L519 651L525 657L535 651L535 649L532 646L534 641L539 641L544 645L554 645L560 649L563 649L571 644L582 643L680 587z"/>
            </g>
            <g class="text">
                <text id="XSQ_Text">
                    <tspan x="340" y="150">锡山区：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['锡山']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['锡山']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['锡山']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan>
                    <tspan x="340" y="270">较上月贷款增长率 {{districtObj['锡山']|getIncreaseRate}}</tspan>
                </text>
                <text id="HSQ_Text">
                    <tspan x="340" y="150">惠山区：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['惠山']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['惠山']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['惠山']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan></tspan>
                    <tspan x="340" y="270">较上月贷款增长率  {{districtObj['惠山']|getIncreaseRate}}</tspan>
                </text>
                <text id="BHQ_Text">
                    <tspan x="340" y="150">滨湖区：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['滨湖']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['滨湖']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['滨湖']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan></tspan>
                    <tspan x="340" y="270">较上月贷款增长率  {{districtObj['滨湖']|getIncreaseRate}}</tspan>
                </text>
                <text id="LXQ_Text">
                    <tspan x="340" y="150">梁溪区：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['梁溪']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['梁溪']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['梁溪']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan></tspan>
                    <tspan x="340" y="270">较上月贷款增长率  {{districtObj['梁溪']|getIncreaseRate}}</tspan>
                </text>
                <text id="XWQ_Text">
                    <tspan x="340" y="150">新吴区：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['新吴']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['新吴']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['新吴']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan></tspan>
                    <tspan x="340" y="270">较上月贷款增长率  {{districtObj['新吴']|getIncreaseRate}}</tspan>
                </text>
                <text id="JY_Text">
                    <tspan x="340" y="150">江阴：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['江阴']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['江阴']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['江阴']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan></tspan>
                    <tspan x="340" y="270">较上月贷款增长率  {{districtObj['江阴']|getIncreaseRate}}</tspan>
                </text>
                <text id="YX_Text">
                    <tspan x="340" y="150">宜兴：</tspan>
                    <tspan x="340" y="180">累计贷款  {{ (districtObj['宜兴']||{}).fi__counts||0}}笔</tspan>
                    <tspan x="340" y="210">在途贷款  {{ (districtObj['宜兴']||{}).fi__processingCount||0}}笔</tspan>
                    <tspan x="340" y="240">实时余额  {{ (Number( (districtObj['宜兴']||{}).fi__balanceAmount||0 )/10000).toFixed(2)}}万元</tspan></tspan>
                    <tspan x="340" y="270">较上月贷款增长率  {{districtObj['宜兴']|getIncreaseRate}}</tspan>
                </text>
            </g>
        </svg>
    </div>
</template>

<script>
    import xhr from "../../../utils/xhr";

    export default {
        name: 'MonitorLeftMap',
        data() {
            return {
                districtObj: {}
            }
        },
        computed: {
            // monitorData() {
            //     return this.$store.state.monitorData||{}
            // },
            // propertyLocationList() {
            //     return this.monitorData.propertyLocationList||[]
            // },
            // districtObj() {
            //     return this.propertyLocationList.reduce((total, item) => {
            //         const district = item.lo__district||''
            //         if (typeof total[district] === 'undefined') {
            //             total[district] = {}
            //             total[district].counts = 0
            //         }
            //         total[district].counts += parseInt(item.fi__counts)
            //
            //         return total
            //     }, {})
            // },
        },
        mounted() {
            this.getFinancingByPropertyLocationVList();
            $(document).ready(function () {
                var i = 0;
                var time;
                var box = $("svg .hand");
                var box_path = $("svg .hand").find("path");
                var box_text = $("svg .text").find("text");
                var Num = $("svg .hand").children("path").length;
                $(box_path).mousemove(function(){
                    $(box_path).removeClass("on");
                    $(this).addClass("on");
                    $(box_text).removeClass("show");
                    $(box_text).eq($(this).index()).addClass("show");
                });
                $(box_path).eq(0).mousemove();
                timestart();
                $(box).hover(
                    function(){
                        clearInterval(time);
                    },
                    function(){
                        timestart();
                    }
                )
                function autoPlay(){
                    if( i >= Num )
                    {
                        i = 0;
                    }
                    $(box_path).eq(i++).mousemove();
                }
                function timestart(){
                    time=setInterval(autoPlay,3000);
                }

            })
        },
        components: {

        },
        props: {

        },
        filters: {
            getIncreaseRate: function (item={}) {
                const totalAmount = Number(item.fi__totalAmount)||0
                const totalAmountByLastMonth = Number(item.fi__totalAmountByLastMonth)||0
                let rate = 0

                if (totalAmountByLastMonth > 0 ) {
                    rate =  ((totalAmount - totalAmountByLastMonth) / totalAmountByLastMonth) * 100


                }

                return (rate >=0 ? '+' + rate.toFixed(2) : rate.toFixed(2)) + '%'
            }
        },
        methods: {
            getFinancingByPropertyLocationVList: function () {
                xhr.getFinancingByPropertyLocationVList(0, ({data})=> {
                    this.districtObj = (data.data||[]).reduce((total, item) => {
                        const district = item.fi__district||''

                        total[district] = item

                        return total
                    }, {})
                })
            }
        },
        beforeDestroy() {
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/monitor/partials/MonitorLeftMap.vue